import i18next from 'i18next';
import { titleize } from 'underscore.string';

export const getLocaleText = () => {
  return {
    // Set Filter
    selectAll: `(${i18next.t('SELECT_ALL')})`,
    selectAllSearchResults: `(${i18next.t('SELECT_ALL_SEARCH_RESULTS')})`,
    searchOoo: `${i18next.t('SEARCH')}...`,
    blanks: `(${i18next.t('BLANK', { count: 1 })})`,
    noMatches: i18next.t('NO_MATCHES'),

    // Number Filter & Text Filter
    filterOoo: `${titleize(i18next.t('FILTER', { count: 1 }))}...`,
    equals: i18next.t('EQUALS'),
    notEqual: i18next.t('NOT_EQUAL'),
    blank: i18next.t('BLANK', { count: 1 }),
    notBlank: i18next.t('NOT_BLANK'),
    empty: i18next.t('CHOOSE_ONE'),

    // Number Filter
    lessThan: i18next.t('LESS_THAN'),
    greaterThan: i18next.t('GREATER_THAN'),
    lessThanOrEqual: i18next.t('LESS_THAN_OR_EQUAL'),
    greaterThanOrEqual: i18next.t('GREATER_THAN_OR_EQUAL'),
    inRange: i18next.t('IN_RANGE'),
    inRangeStart: i18next.t('FROM'),
    inRangeEnd: i18next.t('TO'),

    // Text Filter
    contains: i18next.t('CONTAINS'),
    notContains: i18next.t('NOT_CONTAINS'),
    startsWith: i18next.t('STARTS_WITH'),
    endsWith: i18next.t('ENDS_WITH'),

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',

    // Filter Conditions
    andCondition: i18next.t('AND').toUpperCase(),
    orCondition: i18next.t('OR').toUpperCase(),

    // Filter Buttons
    applyFilter: titleize(i18next.t('APPLY')),
    resetFilter: titleize(i18next.t('RESET')),
    clearFilter: titleize(i18next.t('CLEAR')),
    cancelFilter: titleize(i18next.t('CANCEL')),

    // Filter Titles
    textFilter: i18next.t('TEXT_FILTER'),
    numberFilter: i18next.t('NUMBER_FILTER'),
    dateFilter: i18next.t('DATE_FILTER'),
    setFilter: i18next.t('SET_FILTER'),

    // Side Bar
    columns: titleize(i18next.t('COLUMN', { count: 2 })),
    filters: titleize(i18next.t('FILTER', { count: 2 })),

    // columns tool panel
    pivotMode: i18next.t('PIVOT_MODE'),
    groups: i18next.t('ROW_GROUPS'),
    rowGroupColumnsEmptyMessage: i18next.t('DRAG_SET_ROW_GROUPS'),
    values: i18next.t('VALUES'),
    valueColumnsEmptyMessage: i18next.t('DRAG_TO_AGGREGATE'),
    pivots: i18next.t('COLUMN_LABELS'),
    pivotColumnsEmptyMessage: i18next.t('DRAG_SET_COLUMN_LABELS'),

    // Header of the Default Group Column
    group: titleize(i18next.t('GROUP')),

    // Row Drag
    rowDragRow: i18next.t('ROW', { count: 1 }),
    rowDragRows: i18next.t('ROW', { count: 2 }),

    // Other
    loadingOoo: i18next.t('LOADING'),
    loadingError: i18next.t('ERR'),
    noRowsToShow: i18next.t('NO_ROWS'),
    enabled: titleize(i18next.t('ENABLED')),

    // Menu
    pinColumn: i18next.t('PIN_COLUMN'),
    pinLeft: i18next.t('PIN_LEFT'),
    pinRight: i18next.t('PIN_RIGHT'),
    noPin: i18next.t('NO_PIN'),
    valueAggregation: i18next.t('VALUE_AGGREGATION'),
    autosizeThiscolumn: i18next.t('AUTOSIZE_THIS_COLUMN'),
    autosizeAllColumns: i18next.t('AUTOSIZE_ALL_COLUMNS'),
    groupBy: i18next.t('GROUP_BY'),
    ungroupBy: i18next.t('UN_GROUP_BY'),
    addToValues: i18next.t('ADD_VARIABLE_TO_VALUES'),
    removeFromValues: i18next.t('REMOVE_VARIABLE_FROM_VALUES'),
    addToLabels: i18next.t('ADD_VARIABLE_TO_LABELS'),
    removeFromLabels: i18next.t('REMOVE_VARIABLE_FROM_LABELS'),
    resetColumns: i18next.t('RESET_COLUMNS'),
    expandAll: i18next.t('EXPAND_ALL'),
    collapseAll: i18next.t('COLLAPSE_ALL'),
    copy: titleize(i18next.t('COPY')),
    ctrlC: 'Ctrl+C',
    copyWithHeaders: i18next.t('COPY_WITH_HEADERS'),
    copyWithGroupHeaders: i18next.t('COPY_WITH_GROUP_HEADERS'),
    paste: titleize(i18next.t('PASTE')),
    ctrlV: 'Ctrl+V',
    export: titleize(i18next.t('EXPORT')),
    csvExport: i18next.t('CSV_EXPORT'),
    excelExport: i18next.t('EXCEL_EXPORT'),

    // Enterprise Menu Aggregation and Status Bar
    sum: titleize(i18next.t('SUM')),
    min: titleize(i18next.t('MIN')),
    max: titleize(i18next.t('MAX')),
    none: titleize(i18next.t('NONE')),
    count: titleize(i18next.t('COUNT', { count: 1 })),
    avg: titleize(i18next.t('AVERAGE')),
    filteredRows: titleize(i18next.t('FILTERED')),
    selectedRows: titleize(i18next.t('SELECTED')),
    totalRows: i18next.t('TOTAL_ROWS'),
    totalAndFilteredRows: titleize(i18next.t('ROW', { count: 2 })),
    more: i18next.t('MORE'),
    to: i18next.t('TO'),
    of: i18next.t('OF'),
    page: titleize(i18next.t('PAGE')),
    nextPage: i18next.t('NEXT_PAGE'),
    lastPage: i18next.t('LAST_PAGE'),
    firstPage: i18next.t('FIRST_PAGE'),
    previousPage: i18next.t('PREVIOUS_PAGE'),

    // Pivoting
    pivotColumnGroupTotals: i18next.t('TOTAL'),

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: i18next.t('PIVOT_CHART_AND_MODE'),
    pivotChart: i18next.t('PIVOT_CHART'),
    chartRange: i18next.t('CHART_RANGE'),

    columnChart: titleize(i18next.t('COLUMN', { count: 1 })),
    groupedColumn: titleize(i18next.t('GROUPED')),
    stackedColumn: titleize(i18next.t('STACKED')),
    normalizedColumn: i18next.t('STACKED_100'),

    barChart: titleize(i18next.t('BAR')),
    groupedBar: titleize(i18next.t('GROUPED')),
    stackedBar: titleize(i18next.t('STACKED')),
    normalizedBar: i18next.t('STACKED_100'),

    pieChart: titleize(i18next.t('PIE')),
    pie: titleize(i18next.t('PIE')),
    doughnut: titleize(i18next.t('DOUGHNUT')),

    line: i18next.t('LINE'),

    xyChart: i18next.t('XY_SCATTER'),
    scatter: i18next.t('SCATTER'),
    bubble: i18next.t('BUBBLE'),

    areaChart: titleize(i18next.t('AREA')),
    area: titleize(i18next.t('AREA')),
    stackedArea: titleize(i18next.t('STACKED')),
    normalizedArea: i18next.t('STACKED_100'),

    histogramChart: i18next.t('HISTOGRAM'),
    histogramFrequency: i18next.t('FREQUENCY'),

    combinationChart: titleize(i18next.t('COMBINATION')),
    columnLineCombo: i18next.t('COLUMN_AND_LINE'),
    AreaColumnCombo: i18next.t('AREA_AND_COLUMN'),

    // Charts
    pivotChartTitle: i18next.t('PIVOT_CHART'),
    rangeChartTitle: i18next.t('RANGE_CHART'),
    settings: i18next.t('SETTINGS'),
    data: i18next.t('DATA'),
    format: i18next.t('FORMAT'),
    categories: i18next.t('CATEGORIES'),
    defaultCategory: `(${i18next.t('NONE')})`,
    series: i18next.t('SERIES'),
    xyValues: i18next.t('XY_VALUES'),
    paired: i18next.t('PAIRED_MODE'),
    axis: titleize(i18next.t('AXIS')),
    navigator: titleize(i18next.t('NAVIGATOR')),
    color: titleize(i18next.t('COLOR')),
    thickness: titleize(i18next.t('THICKNESS')),
    xType: i18next.t('X_TYPE'),
    automatic: titleize(i18next.t('AUTOMATIC')),
    category: titleize(i18next.t('CATEGORY')),
    number: titleize(i18next.t('NUMBER')),
    time: titleize(i18next.t('TIME')),
    autoRotate: i18next.t('AUTO_ROTATE'),
    xRotation: i18next.t('X_ROTATION'),
    yRotation: i18next.t('Y_ROTATION'),
    ticks: titleize(i18next.t('TICKS')),
    width: titleize(i18next.t('WIDTH')),
    height: titleize(i18next.t('HEIGHT')),
    length: titleize(i18next.t('LENGTH')),
    padding: titleize(i18next.t('PADDING')),
    spacing: titleize(i18next.t('SPACING')),
    chart: titleize(i18next.t('CHART')),
    title: titleize(i18next.t('TITLE')),
    titlePlaceholder: i18next.t('CHART_TITLE_EDIT_TIP'),
    background: i18next.t('BACKGROUND'),
    font: titleize(i18next.t('FONT')),
    top: titleize(i18next.t('TOP')),
    right: titleize(i18next.t('RIGHT')),
    bottom: titleize(i18next.t('BOTTOM')),
    left: titleize(i18next.t('LEFT')),
    labels: titleize(i18next.t('LABELS')),
    size: titleize(i18next.t('SIZE', { count: 1 })),
    minSize: i18next.t('MINIMUM_SIZE'),
    maxSize: i18next.t('MAXIMUM_SIZE'),
    legend: titleize(i18next.t('LEGEND')),
    position: titleize(i18next.t('POSITION')),
    markerSize: i18next.t('MARKER_SIZE'),
    markerStroke: i18next.t('MARKER_STROKE'),
    markerPadding: i18next.t('MARKER_PADDING'),
    itemSpacing: i18next.t('ITEM_SPACING'),
    itemPaddingX: i18next.t('ITEM_PADDING_X'),
    itemPaddingY: i18next.t('ITEM_PADDING_Y'),
    layoutHorizontalSpacing: i18next.t('HORIZONTAL_SPACING'),
    layoutVerticalSpacing: i18next.t('VERTICAL_SPACING'),
    strokeWidth: i18next.t('STROKE_WIDTH'),
    lineDash: i18next.t('LINE_DASH'),
    offset: titleize(i18next.t('OFFSET', { count: 1 })),
    offsets: titleize(i18next.t('OFFSET', { count: 2 })),
    tooltips: titleize(i18next.t('TOOLTIP', { count: 2 })),
    callout: titleize(i18next.t('CALLOUT')),
    markers: titleize(i18next.t('MARKERS')),
    shadow: titleize(i18next.t('SHADOW')),
    blur: titleize(i18next.t('BLUR')),
    xOffset: i18next.t('X_OFFSET'),
    yOffset: i18next.t('Y_OFFSET'),
    lineWidth: i18next.t('LINE_WIDTH'),
    normal: titleize(i18next.t('NORMAL')),
    bold: titleize(i18next.t('BOLD')),
    italic: titleize(i18next.t('ITALIC')),
    boldItalic: i18next.t('BOLD_ITALIC'),
    predefined: titleize(i18next.t('PREDEFINED')),
    fillOpacity: i18next.t('FILL_OPACITY'),
    strokeOpacity: i18next.t('LINE_OPACITY'),
    histogramBinCount: i18next.t('BIN_COUNT'),
    columnGroup: titleize(i18next.t('COLUMN', { count: 1 })),
    barGroup: titleize(i18next.t('BAR')),
    pieGroup: titleize(i18next.t('PIE')),
    lineGroup: titleize(i18next.t('LINE')),
    scatterGroup: i18next.t('XY_SCATTER'),
    areaGroup: titleize(i18next.t('AREA')),
    histogramGroup: titleize(i18next.t('HISTOGRAM')),
    combinationGroup: titleize(i18next.t('COMBINATION')),
    groupedColumnTooltip: titleize(i18next.t('GROUPED')),
    stackedColumnTooltip: titleize(i18next.t('STACKED')),
    normalizedColumnTooltip: i18next.t('STACKED_100'),
    groupedBarTooltip: titleize(i18next.t('GROUPED')),
    stackedBarTooltip: titleize(i18next.t('STACKED')),
    normalizedBarTooltip: i18next.t('STACKED_100'),
    pieTooltip: titleize(i18next.t('PIE')),
    doughnutTooltip: titleize(i18next.t('DOUGHNUT')),
    lineTooltip: titleize(i18next.t('LINE')),
    groupedAreaTooltip: titleize(i18next.t('AREA')),
    stackedAreaTooltip: titleize(i18next.t('STACKED')),
    normalizedAreaTooltip: i18next.t('STACKED_100'),
    scatterTooltip: titleize(i18next.t('SCATTER')),
    bubbleTooltip: titleize(i18next.t('BUBBLE')),
    histogramTooltip: titleize(i18next.t('HISTOGRAM')),
    columnLineComboTooltip: i18next.t('COLUMN_AND_LINE'),
    areaColumnComboTooltip: i18next.t('AREA_AND_COLUMN'),
    customComboTooltip: i18next.t('CUSTOM_COMBINATION'),
    noDataToChart: i18next.t('NO_DATA_AVAILABLE_CHARTED'),
    pivotChartRequiresPivotMode: i18next.t('PIVOT_CHART_REQUIRES_MODE_ENABLED'),
    chartSettingsToolbarTooltip: i18next.t('MENU'),
    chartLinkToolbarTooltip: i18next.t('LINKED_TO_GRID'),
    chartUnlinkToolbarTooltip: i18next.t('UNLINKED_FROM_GRID'),
    chartDownloadToolbarTooltip: i18next.t('DOWLOAD_CHART'),
    seriesChartType: i18next.t('SERIES_CHART_TYPE'),
    seriesType: i18next.t('SERIES_TYPE'),
    secondaryAxis: i18next.t('SECONDARY_AXIS'),

    // ARIA
    ariaChecked: i18next.t('CHECKED'),
    ariaColumn: titleize(i18next.t('COLUMN', { count: 1 })),
    ariaColumnGroup: i18next.t('COLUMN_GROUP'),
    ariaColumnList: i18next.t('COLUMN_LIST'),
    ariaColumnSelectAll: i18next.t('TOGGLE_SELECT_ALL_COLUMNS'),
    ariaDateFilterInput: i18next.t('DATE_FILTER_INPUT'),
    ariaDefaultListName: titleize(i18next.t('LIST')),
    ariaFilterColumnsInput: i18next.t('FILTER_COLUMNS_INPUT'),
    ariaFilterFromValue: i18next.t('FILTER_FROM_VALUE'),
    ariaFilterInput: i18next.t('FILTER_INPUT'),
    ariaFilterList: i18next.t('FILTER_LIST'),
    ariaFilterToValue: i18next.t('FILTER_TO_VALUE'),
    ariaFilterValue: i18next.t('FILTER_VALUE'),
    ariaFilteringOperator: i18next.t('FILTERING_OPERATOR'),
    ariaHidden: i18next.t('HIDDEN'),
    ariaIndeterminate: i18next.t('INDETERMINATE'),
    ariaInputEditor: i18next.t('INPUT_EDITOR'),
    ariaMenuColumn: i18next.t('CTRL_ENTER_TO_OPEN_COLUMN_MENU'),
    ariaRowDeselect: i18next.t('SPACE_TO_DESELECT_ROW'),
    ariaRowSelectAll: i18next.t('SPACE_TO_TOGGLE_ALL_ROW_SELECTION'),
    ariaRowToggleSelection: i18next.t('SPACE_TO_TOGGLE_ROW_SELECTION'),
    ariaRowSelect: i18next.t('SPACE_TO_SELECT_ROW'),
    ariaSearch: titleize(i18next.t('SEARCH')),
    ariaSortableColumn: i18next.t('ENTER_TO_SORT'),
    ariaToggleVisibility: i18next.t('SPACE_TO_TOGGLE_VISIBILITY'),
    ariaUnchecked: i18next.t('UNCHECKED'),
    ariaVisible: i18next.t('VISIBLE'),
    ariaSearchFilterValues: i18next.t('SEARCH_FILTER_VALUES'),

    // ARIA Labels for Drop Zones

    ariaRowGroupDropZonePanelLabel: i18next.t('ROW_GROUPS'),
    ariaValuesDropZonePanelLabel: i18next.t('VALUES'),
    ariaPivotDropZonePanelLabel: i18next.t('COLUMN_LABELS'),
    ariaDropZoneColumnComponentDescription: i18next.t('DELETE_TO_REMOVE'),
    ariaDropZoneColumnValueItemDescription: i18next.t(
      'ENTER_TO_CHANGE_AGGREGATION_TYPE',
    ),
    ariaDropZoneColumnGroupItemDescription: i18next.t('ENTER_TO_SORT'),
    // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeperator}{column name}
    ariaDropZoneColumnComponentAggFuncSeperator: ` ${i18next.t('OF')} `,
    ariaDropZoneColumnComponentSortAscending: titleize(i18next.t('ASCENDING')),
    ariaDropZoneColumnComponentSortDescending: titleize(
      i18next.t('DESCENDING'),
    ),

    // ARIA Labels for Dialogs
    ariaLabelColumnMenu: i18next.t('COLUMN_EDITOR'),
    ariaLabelCellEditor: i18next.t('CELL_EDITOR'),
    ariaLabelDialog: i18next.t('DIALOG'),
    ariaLabelSelectField: i18next.t('SELECT_FIELD'),
    ariaLabelTooltip: titleize(i18next.t('TOOLTIP', { count: 1 })),
    ariaLabelContextMenu: 'Context Menu',
    ariaLabelSubMenu: i18next.t('SUB_MENU'),
    ariaLabelAggregationFunction: i18next.t('AGGREGATION_FUNCTION'),

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: ',',
    decimalSeparator: '.',
  };
};
